// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__7wcnl","loading_spinne":"styles_loading_spinne__HBoop","spin":"styles_spin__j7UIw"};